var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.372 1.40948C11.2932 0.578712 9.79015 0.578711 8.71131 1.40948L1.16964 7.21696C0.432109 7.7849 0 8.66303 0 9.59389V20C0 21.6569 1.34315 23 3 23H4.14113C5.79798 23 7.14113 21.6569 7.14113 20V17.2059C7.14113 15.549 8.48427 14.2059 10.1411 14.2059H10.9422C12.5991 14.2059 13.9422 15.549 13.9422 17.2059V20C13.9422 21.6569 15.2853 23 16.9422 23H18.0833C19.7402 23 21.0833 21.6569 21.0833 20V9.59389C21.0833 8.66303 20.6512 7.7849 19.9137 7.21696L12.372 1.40948Z",
    fill: "#6F82C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHeader);
export default __webpack_public_path__ + "static/media/home_header.0c46dedf49579cc480ada63cc8203768.svg";
export { ForwardRef as ReactComponent };